import axios from '@/axios.js'

export default {
  fetchEvents ({ commit }) {
    commit('SET_EVENTS', [])
    return new Promise((resolve, reject) => {
      axios
        .get('/api/support/events')
        .then(response => {
          commit('SET_EVENTS', response.data.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  fetchEvent (context, eventId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/support/event/${eventId}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  deleteEvent (context, eventId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/support/event/delete/${eventId}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateEvent (context, form) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`/api/support/event/update/${form.id}`, form)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  fetchServiceRequest ({ commit }) {
    commit('SET_SERVICEREQUEST', [])
    return new Promise((resolve, reject) => {
      axios
        .get('/api/support/service-requests')
        .then(response => {
          commit('SET_SERVICEREQUEST', response.data.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  fetchServiceRequests (context, servicerequest_id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/support/service-request/${servicerequest_id}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  deleteServiceRequests (context, servicerequest_id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/support/service-request/delete/${servicerequest_id}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  fetchTransaction (context, transaction_id) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/support/transaction/${transaction_id}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  deleteTransaction (context, transaction_id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/support/transaction/delete/${transaction_id}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  removeRecord ({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/user-management/users/${userId}`)
        .then(response => {
          commit('REMOVE_RECORD', userId)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}
